<template>
  <div>
    <b-container fluid class="px-0">
      <div class="page-head">
        <h3>POS</h3>
      </div>

      <b-row class="form-card mx-0 pb-3">
        <b-col>
          <b-form>
            <b-form-input  v-model="invoice.paymentType">
            </b-form-input>
          </b-form>
        </b-col>

      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    invoice: {
      client: {},
      items: {},
      desc: '',
      paid: true,
      paidAmount: 0,
      paymentType: 0,
    },
  }),
};
</script>

<style>

</style>
